import Vue from "vue";
import Vuetify from "vuetify/lib";
import VueLocalStorage from "vue-localstorage";
//import "@mdi/font/css/materialdesignicons.css";

import de from "vuetify/es5/locale/de";
import es from "vuetify/es5/locale/es";

const opts = {
  lang: {
    locales: { de, es },
    current: Vue.localStorage.get("language") || "de"
  },
  theme: {
    themes: {
      light: {
        primary: "#B31616",
        secondary: "#8D919A",
        textColor: "#FFFFFF",
        navigationItemListColor: "black"
      },
      dark: {
        primary: "#B31616",
        secondary: "#8D919A",
        textColor: "#FFFFFF",
        navigationItemListColor: "white"
      }
    }
  },
  icons: {
    iconfont: "mdiSvg"
  }
};

Vue.use(Vuetify);

export default new Vuetify(opts);
